import { Item } from './styles'

const Component = ({children, ...rest}:any) =>{
  return <Item {...rest}>{children}</Item>
}

export default Component